import Vue from 'vue';
import store from '@/store';

Vue.filter('translate', key => store.state.translations[key] || key);

Vue.filter('uppercase', string => string.toUpperCase());

Vue.filter('capitalize', (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
});

Vue.filter('rounding', (value, decimals = 2) => {
  if (typeof value !== 'number') {
    return value;
  }
  return (value.toFixed(decimals)).replace('.', ',');
});

Vue.filter('ranking', (value) => {
  if (typeof value !== 'number') {
    return value;
  }
  const rankings = {
    1: 'st',
    2: 'nd',
    3: 'rd',
    default: 'th',
  };
  return value + rankings[value] || value + rankings.default;
});
